import { useNumericQueryParam } from './numeric-query-param-helper';

export function useTabIndexInUrl(
  paramName = 'aba',
): [number, (index: number) => void] {
  const [tabIndex, setTabIndex] = useNumericQueryParam(paramName);
  return [tabIndex ?? 0, setTabIndex];
}
